class GetInTouchForm {
    showChildrenGuestsSelector = false;

    isLoading = false;

    currentImage = "yellow-canyon";

    init() {
        this.isLoading = false;

        window.addEventListener("pegasusformlocationupdate", (e) => {
            this.currentImage = "locations/" + e.detail;
        });

        document.addEventListener("gform/post_init", (event) => {
            this.getImageUpdates();
            this.handleDateFields();
            this.addChildrenGuestsSelector();
            this.handlePhoneNumberInput();

            this.isLoading = false;

            const formId = event.detail.formId;

            const nextButton = this.$el.querySelector(
                `#gform_next_button_${formId}_46`
            );

            if (nextButton) {
                nextButton.addEventListener("click", (event) => {
                    // check current page fields are valid
                    const currentPageFields = this.$el.querySelectorAll(
                        `#gform_page_${formId}_7 .gfield input, #gform_page_${formId}_7 .gfield select`
                    );

                    let isValid = true;
                    currentPageFields.forEach((field) => {

                        if (field && !field.value) {
                            isValid = false;
                        }
                    });
                    if (!isValid) {
                        event.preventDefault();
                        return;
                    }

                    this.isLoading = true;
                });
            }

            const childrenRadioGroup = this.$el.querySelectorAll(
                '.children-selector input[type="radio"][name="input_23"]'
            );

            if (!childrenRadioGroup || childrenRadioGroup.length === 0) {
                return;
            }

            childrenRadioGroup.forEach((radio) => {
                const radioLabel = radio.nextElementSibling;
                radioLabel.addEventListener("click", (event) => {
                    this.$nextTick(() => {
                        this.addChildrenGuestsSelector(true);
                    });
                });
            });
        });
    }

    goBackToForm(formId) {
        var prevPage = localStorage.getItem("gf_prev_page_" + formId) || 1;
        var formUrl =
            window.location.href.split("?")[0] + "?gf_page=" + prevPage;
        window.location.href = formUrl;
    }

    addChildrenGuestsSelector() {
        const childRadioElements = this.$root.querySelectorAll(
            '.children-selector input[type="radio"][name="input_23"]'
        );
        const addChildrenSelector = this.$root.querySelector(
            '.children-selector input[type="radio"][name="input_23"][value="Add children"]'
        ).parentElement;

        childRadioElements.forEach((radio) => {
            if (radio.value === "Add children" && radio.checked) {
                this.showChildrenGuestsSelector = true;
            }
        });

        if (this.showChildrenGuestsSelector) {
            addChildrenSelector.style.display = "none";
        } else {
            addChildrenSelector.style.display = "";
        }
    }

    handleNumberFields() {
        this.$root
            .querySelectorAll(".ginput_container_number")
            .forEach((input) => {
                const number = input.querySelector('input[type="number"]');
                //set the number value to the minimum value
                input.addEventListener("click", function (event) {
                    const rect = this.getBoundingClientRect();
                    const clickX = event.clientX - rect.left;

                    // Check if the click is on the left or right of the input
                    if (clickX < 30) {
                        number.stepDown(1);
                        // number.value = number.value;
                    } else if (clickX > rect.width - 30) {
                        // Increment (right side)
                        number.stepUp(1);
                        // number.value = number.value;
                    }

                    // Trigger change event
                    number.dispatchEvent(
                        new Event("change", { bubbles: true })
                    );
                    number.dispatchEvent(
                        new CustomEvent("gform_input_change", {
                            bubbles: true,
                            detail: { field: number },
                        })
                    );
                });
            });
    }

    getImageUpdates() {
        const form = this.$root.querySelector("form");

        if (!form) {
            return;
        }

        const formData = new FormData(form);

        const locationField = formData.getAll("input_53");

        if (locationField.length === 0) {
            return;
        }

        window.dispatchEvent(
            new CustomEvent("pegasusformlocationupdate", {
                detail: locationField[0].replaceAll(" ", "-"),
            })
        );
    }

    handleDateFields() {
        let checkedMonthRadio = this.$root.querySelector(
            '.gfield input[type="radio"][name="input_11"]:checked'
        );

        const date = new Date();
        const currentYear = date.getFullYear().toString().slice(-2);

        const moreMonths = this.$root.querySelector(".more-months");

        if (
            checkedMonthRadio &&
            parseInt(this.getDateArray(checkedMonthRadio)[1]) >=
                parseInt(currentYear) + 2
        ) {
            this.showMonths();
            moreMonths.style.display = "none";
        } else {
            this.hideMonths();
        }

        this.handleMoreMonths();

        this.updateMonths();
    }

    getMonthsHeight() {
        const monthsField = this.$root.querySelector(".months-field");

        if (!monthsField) {
            return;
        }

        const radioGroup = monthsField.querySelector(".gfield_radio");

        if (!radioGroup || radioGroup.length === 0) {
            return;
        }

        radioGroup.style.height = "";

        const radioGroupHeight = radioGroup.offsetHeight;

        return radioGroupHeight;
    }

    hideMonths() {
        const monthsField = this.$root.querySelector(".months-field");

        if (!monthsField) {
            return;
        }

        const radioGroup = monthsField.querySelector(".gfield_radio");

        if (!radioGroup || radioGroup.length === 0) {
            return;
        }

        let monthsHeight = this.getMonthsHeight();

        radioGroup.classList.add("overflow-hidden");

        radioGroup.style.height = `${monthsHeight / 2}px`;

        window.addEventListener("resize", () => {
            monthsHeight = this.getMonthsHeight();
            radioGroup.style.height = `${monthsHeight / 2}px`;
        });
    }

    showMonths() {
        const monthsField = this.$root.querySelector(".months-field");

        if (!monthsField) {
            return;
        }

        const radioGroup = monthsField.querySelector(".gfield_radio");

        if (!radioGroup || radioGroup.length === 0) {
            return;
        }

        let monthsHeight = this.getMonthsHeight();

        radioGroup.style.height = `${monthsHeight}px`;

        window.addEventListener("resize", () => {
            monthsHeight = this.getMonthsHeight();
            radioGroup.style.height = `${monthsHeight}px`;
        });
    }

    handleMoreMonths() {
        const moreMonths = this.$root.querySelector(".more-months");
        const input = moreMonths.querySelector('input[type="radio"]');

        if (!input) {
            return;
        }

        if (input.checked) {
            this.showMonths();

            moreMonths.remove();
        }

        input.addEventListener("change", (event) => {
            if (input.checked) {
                this.showMonths();

                moreMonths.remove();
            }
        });
    }

    updateMonths() {
        const monthRadios = this.$root.querySelectorAll(
            '.gfield input[type="radio"][name="input_11"]'
        );

        if (!monthRadios || monthRadios.length === 0) {
            return;
        }

        const date = new Date();
        const currentYear = date.getFullYear().toString().slice(-2);

        // Loop through month radios and if it's value is not available for the selected year, disabled it and lower opacity otherwise enable it
        monthRadios.forEach((radio) => {
            const dateArray = this.getDateArray(radio);
            if (
                !this.isMonthAvailable(dateArray[1], dateArray[0]) ||
                (parseInt(dateArray[1]) >= parseInt(currentYear) + 3 &&
                    this.isMonthAvailable(currentYear, dateArray[0]))
            ) {
                radio.classList.add("disabled");
                // radio.setAttribute('disabled', 'disabled');
            } else {
                // radio.removeAttribute('disabled');
                radio.classList.remove("disabled");
            }

            radio.addEventListener("change", (event) => {
                const yearField = this.$root.querySelector(
                    '.gfield input[type="hidden"][name="input_115"]'
                );

                const monthField = this.$root.querySelector(
                    '.gfield input[type="hidden"][name="input_119"]'
                );

                if (!yearField || !monthField) {
                    return;
                }

                const selectedYear = "20" + dateArray[1];

                yearField.value = selectedYear;
                monthField.value = dateArray[0];
            });
        });
    }

    getDateArray(radio) {
        // Get next sibling of radio
        const label = radio.nextElementSibling;

        // get text content of label
        const date = label.textContent;

        const dateArray = date.split(" ");

        Object.entries(this.getMonths()).forEach(([key, value]) => {
            if (dateArray[0] === value) {
                dateArray[0] = key;
            }
        });

        // Split date by space
        return dateArray;
    }

    getMonths() {
        return {
            January: "Jan",
            February: "Feb",
            March: "Mar",
            April: "Apr",
            May: "May",
            June: "Jun",
            July: "Jul",
            August: "Aug",
            September: "Sep",
            October: "Oct",
            November: "Nov",
            December: "Dec",
        };
    }

    getAvailableMonthsLeftInCurrentYear() {
        let months = [];
        let currentMonth = new Date().getMonth();
        let monthsLeft = 12 - currentMonth;
        for (let i = 0; i < monthsLeft; i++) {
            months.push(Object.keys(this.getMonths())[currentMonth + i]);
        }
        return months;
    }

    isMonthAvailable(year, month) {
        const date = new Date();
        const currentYear = date.getFullYear().toString().slice(-2);
        if (year == currentYear) {
            return this.getAvailableMonthsLeftInCurrentYear().includes(month);
        }

        return true;
    }

    handlePhoneNumberInput() {
        const phoneInput = document.querySelector("input[type='tel']");
        const hiddenCountryCode = document.querySelector(
            "input[name='input_96']"
        );
        const hiddenPhone = document.querySelector("input[name='input_98']");
        const selectedCountry = document
            .querySelector("button.iti__selected-country")
            .getAttribute("title");
        const selectedCode = document.querySelector(
            "button.iti__selected-country .iti__selected-dial-code"
        ).textContent;

        if (!phoneInput || !hiddenCountryCode || !hiddenPhone) {
            return;
        }

        phoneInput.setAttribute("type", "text");
        phoneInput.id = "intl-phone";

        hiddenPhone.id = "phone";

        if (selectedCountry !== "Unknown") {
            hiddenCountryCode.value = selectedCountry;
        }

        hiddenPhone.value = selectedCode + phoneInput.value;
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("getInTouchForm", () => new GetInTouchForm());
});
